import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './Banner.css';

class Banner extends Component {

    render() {
        return (
            <section id={this.props.id} className='banner text-center vertical-center'>

                <Container>
                    <Row>
                        {this.getContent()}
                    </Row>
                </Container>

            </section>
        );
    }

    getContent() {
        return <Col data-aos='fade-up'>
            <h2 className='display-4'>
                <span className='gradient-primary gradient-text fw-bold'>Software that delivers. </span><br/>
                {this.props.title}
            </h2>
            <p className='lead'>
                {this.props.text}
            </p>
        </Col>;
    }

}

export default Banner;